import { Component, Input, OnInit } from "@angular/core";
import { UserService } from "../../../../../shared";
import { SysAdminService } from "../../../services/sysadmin.service";
import { IntListRequest } from "../../../services/IntListRequest";

@Component({
	selector: "caass-user-modify-email",
	templateUrl: "./user-modify-email.component.html",
	styleUrls: ["./user-modify-email.component.css"],
})
export class UserModifyEmailComponent implements OnInit {
	constructor(private sysAdminService: SysAdminService, private userService: UserService) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadUserData();
	}

	ngOnChanges() {
		this.loadUserData();
	}

	loadUserData() {
		if (this.EditMode == true) {
			if (this.UserID > 0 && this.EditInitLoad == false) {
				this.EditInitLoad = true;

				this.loadUserEmails();
			} else {
				this.loadEmails();
			}
		} else {
			this.loadEmails();
		}
	}

	/////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////

	user: any;

	NewInitLoad: any = false;
	EditInitLoad: any = false;

	@Input() EditMode: any = false;
	@Input() UserID: any = -1;

	@Input() Username: any = "";
	@Input() PersonName: any = "";

	@Input() lstSchool: any = [];
	@Input() UserAdminManualEmail: boolean = false;
	@Input() Processing: any;

	DomainOption: any = "Dropdown"; //Dropdown, Manual

	Email: any = "";
	EmailID: any = -1;

	EmailDomain: any;
	lstEmailDomain: any = [];

	UserData: any;

	loading: boolean = false;

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////

	loadUserEmails() {
		this.loading = true;

		var result = this.sysAdminService.SysAdminUserEmailSelect(this.UserID);
		result.subscribe(
			(response) => {
				this.UserData = response[0];

				if (this.UserData != undefined) {
					this.Email = this.UserData.EMailAddress;

					if (this.UserData.EmailProviderID <= 0) {
						this.DomainOption = "Manual";
					}

					this.EmailID = this.UserData.EmailID;
				}

				this.loadEmails();
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	loadEmails() {
		var SIDs: number[] = [];

		SIDs = [...SIDs, -1];

		if (this.lstSchool != undefined) {
			for (var z = 0; z < this.lstSchool.length; z++) {
				var next = this.lstSchool[z];

				SIDs = [...SIDs, next.SchoolID];
			}
		}

		var parms: IntListRequest = {
			lstIDs: SIDs,
		};

		var result = this.sysAdminService.SysAdminEmailSelectListBySchools(parms);
		result.subscribe(
			(response) => {
				this.loading = false;

				this.lstEmailDomain = response;

				this.EmailDomain = this.lstEmailDomain[0];

				if (this.UserData != undefined) {
					for (var z = 0; z < this.lstEmailDomain.length; z++) {
						var next = this.lstEmailDomain[z];

						if (next.EmailProviderID == this.UserData.EmailProviderID) {
							this.EmailDomain = next;
							return;
						}
					}
				}
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////
	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	IsLoading() {
		return this.loading == true || this.Processing == true;
	}

	/////////////////////////////////////////////////////////////////
}
